const getLastItem = <T>(array: T[]) => array[array.length - 1];

export default getLastItem;
